<template>
  <div v-if="isOpenLayerPopup" class="full-layer">
    <Adult
      @enter-fn="onClickVerification"
      @exit-fn="onClickRouterBack"
    />
  </div>
</template>

<script>
import { ADULT_LAYER_POPUP } from '@/common/resources/const'
import { EventBus, setCookieVerifiedAdult } from '@/common/utils/adult'
import Adult from '@/components/adult/Adult'

export default {
  name: 'AdultLayerPopup',
  components: {
    Adult
  },
  data () {
    return {
      isLayerPopup: false
    }
  },
  computed: {
    isOpenLayerPopup () {
      const layerPopupRoutes = ['player', 'instantlist'] // 성인인증 풀페이지 팝업이 가능한 라우터 배열
      const path = this.$route?.fullPath ?? ''
      const isLayerPopupRoute = layerPopupRoutes.filter(route => path.match(new RegExp(`/(${route})`, `gi`))).length > 0

      return this.isLayerPopup && isLayerPopupRoute
    }
  },
  mounted () {
    EventBus.$on(ADULT_LAYER_POPUP, this.isOpen)
  },
  beforeUpdate () {
    this.isLayerPopup = this.isOpenLayerPopup
  },
  methods: {
    isOpen ({ isOpen = false }) {
      this.isLayerPopup = isOpen
    },
    onClickVerification () {
      setCookieVerifiedAdult()
      this.isLayerPopup = false
    },
    onClickRouterBack () {
      this.$router.back()
    }
  }
}
</script>
